import { Injectable } from '@angular/core';

export interface LanguageFlags {
  key: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class LanguageConverterService {

  flags: LanguageFlags[] = [
    {key: 'pl', name: 'pl'},
    {key: 'en', name: 'gb'},
    {key: 'de', name: 'de'},
    {key: 'ru', name: 'ru'},
    {key: 'fr', name: 'fr'},
    {key: 'cs', name: 'cs'},
    {key: 'hu', name: 'hu'},
    {key: 'pt', name: 'pt'},
    {key: 'it', name: 'it'},
    {key: 'ua', name: 'ua'},
    {key: 'uk', name: 'ua'},
    {key: 'es', name: 'es'}
  ];

  constructor() { }

  public convertToCountry(id: string) {
    return this.flags.filter(value => value.key === id).map(object => object.name);
  }

  buidlLanguageFlagsForLocale(locale: string) {
    const array = this.flags.filter(x => locale !== x.key);
    const arraychhosed = this.flags.filter(x => locale === x.key);
    return [...arraychhosed, ...array, ];
  }
}
